const productVisibility = {
  invisible: 'INVISIBLE',
  visible: 'VISIBLE',
  outOfStock: 'OUT_OF_STOCK',
  landing: 'LANDING',
}


export default productVisibility
